import { failure, pending, ReduxAction, success } from '../../core';
import { Account } from '../../../api/accounts.types';
import { CartActions } from './actions';
import { CartState } from './types';

const initialState: CartState = {
  account: null,
  isUpdating: false,
  hasErrors: false,
};

export function cartReducer(state: CartState = initialState, action: ReduxAction<any>): CartState {
  switch (action.type) {
    case pending(CartActions.EDIT_ACCOUNT):
      return {
        ...state,
        isUpdating: true,
        hasErrors: false,
      };

    case success(CartActions.EDIT_ACCOUNT):
      return {
        ...state,
        account: {
          userAccountId: action.data.userAccountId,
          avatarUrl: action.data.avatarUrl,
          fullName: action.data.fullName,
          phoneNumber: action.data.phoneNumber,
          email: action.data.email,
          firstName: action.data.firstName,
          lastName: action.data.lastName,
          zipcode: action.data.signupZipcode,
        } as Account,
        isUpdating: false,
      };

    case failure(CartActions.EDIT_ACCOUNT):
      return {
        ...state,
        isUpdating: false,
        hasErrors: true,
      };

    default:
      return state;
  }
}
